import tokenStore from './token_store'

// @namespace Ajax.Csrf
export default class Read {
  constructor (cache, nextAjax) {
    this.ajax = this.ajax.bind(this)
    this.nextAjax = nextAjax
  }

  ajax (options) {
    const jqXHR = this.nextAjax(options)

    if (tokenStore.expectedFor(options.url) && !options.firehose) {
      jqXHR.done((data, status, xhr) => {
        const tokenHeader = xhr.getResponseHeader('X-CSRF-Token')
        if (tokenHeader) { tokenStore.set(options.url, tokenHeader) }
      })
    }
    return jqXHR
  }
}
